import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=f6af4a86&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=ts&"
export * from "./AppFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=f6af4a86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af4a86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6af4a86')) {
      api.createRecord('f6af4a86', component.options)
    } else {
      api.reload('f6af4a86', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=f6af4a86&scoped=true&", function () {
      api.rerender('f6af4a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppContainer/AppFooter.vue"
export default component.exports